import { useRender } from '@base-ui/react/use-render';
import { clsx } from 'clsx';
import { Avatar } from '../avatar/avatar.tsx';
import { handleV2, handleV2Label } from './handle-v2.css.ts';

export type HandleV2Props = Omit<
  useRender.ComponentProps<'div'>,
  'children'
> & {
  handle: string;
  avatarSrc?: string | null;
};

export const HandleV2 = ({
  handle,
  avatarSrc,
  className,
  render,
  ref,
  ...elementProps
}: HandleV2Props) =>
  useRender({
    defaultTagName: 'div',
    render,
    ref,
    props: {
      ...elementProps,
      className: clsx(handleV2, className),
      children: (
        <>
          <Avatar size="v2s" imageSrc={avatarSrc} />
          <span className={handleV2Label}>@{handle}</span>
        </>
      ),
    },
  });
